import { X, Copy } from 'lucide-react'
import { useRef } from 'react'

interface TextSelectSheetProps {
  text: string
  userName: string
  isOpen: boolean
  onClose: () => void
}

export function TextSelectSheet({ text, userName, isOpen, onClose }: TextSelectSheetProps) {
  const textRef = useRef<HTMLDivElement>(null)

  if (!isOpen) return null

  const handleCopySelection = () => {
    const selection = window.getSelection()
    if (selection && selection.toString().trim()) {
      navigator.clipboard.writeText(selection.toString()).catch(() => {})
    }
  }

  return (
    <>
      <div className="fixed inset-0 bg-black/30 z-50" onClick={onClose} />
      <div className="fixed inset-x-0 bottom-0 z-50 bg-surface-primary rounded-t-2xl shadow-2xl pb-safe animate-in slide-in-from-bottom duration-200 max-h-[70vh] flex flex-col">
        {/* Handle */}
        <div className="flex justify-center pt-3 pb-2 flex-shrink-0">
          <div className="w-10 h-1 rounded-full bg-surface-tertiary" />
        </div>

        {/* Header */}
        <div className="flex items-center justify-between px-4 py-2 border-b border-base flex-shrink-0">
          <span className="text-sm font-medium text-heading">텍스트 선택</span>
          <div className="flex items-center gap-2">
            <button
              onClick={handleCopySelection}
              className="p-1.5 rounded-lg text-primary-500 hover-surface"
              title="선택 영역 복사"
            >
              <Copy className="w-4.5 h-4.5" />
            </button>
            <button onClick={onClose} className="p-1.5 rounded-lg text-caption hover-surface">
              <X className="w-4.5 h-4.5" />
            </button>
          </div>
        </div>

        {/* 선택 가능한 텍스트 영역 */}
        <div className="flex-1 overflow-y-auto p-4">
          <p className="text-meta text-caption mb-2">{userName}</p>
          <div
            ref={textRef}
            className="text-sm text-heading leading-relaxed whitespace-pre-wrap break-words"
            style={{ userSelect: 'text', WebkitUserSelect: 'text' }}
          >
            {text}
          </div>
        </div>

        <div className="px-4 py-3 border-t border-base flex-shrink-0">
          <p className="text-meta text-disabled text-center">텍스트를 드래그하여 선택한 후 복사 버튼을 누르세요</p>
        </div>
      </div>
    </>
  )
}
